<div class="pb-24" skeletonScreen [showSkeleton]="isLoading">
    @if (hasValidClient() && !isRescheduleAppointment) {
        <div class="flex items-center justify-center gap-2 mb-2" skeletonData>
            @if (appointmentRequest.client.firstName && appointmentRequest.client.lastName) {
                <h4 class="text-sm font-semibold">{{ appointmentRequest.client.firstName }} {{ appointmentRequest.client.lastName }}</h4>
            } @else if (appointmentRequest.client.email) {
                <h4 class="text-sm font-semibold">
                    {{ appointmentRequest.client.email }}
                </h4>
            }

            @if (isTextLoaded) {
                @if (featureEnabledAndUserLoggedIn) {
                    <button
                        hlmBtn
                        variant="link"
                        size="icon"
                        class="text-primary-dark text-md font-normal underline ml-8 mb-1"
                        (click)="onClickNotYou()"
                    >
                        Not you?
                    </button>
                    <!-- The Edit button will not be shown when only the email is present -->
                } @else if (!(appointmentRequest.client.email && !appointmentRequest.client.firstName)) {
                    <button
                        hlmBtn
                        variant="link"
                        size="icon"
                        class="text-primary-dark text-lg underline-offset-2 hover:underline ml-2 mb-1"
                        (click)="onClickEdit()"
                    >
                        Edit
                    </button>
                }
            }
        </div>
    }

    <!-- Old Appointment Section -->
    <div *ngIf="isRescheduleAppointment && oldAppointmentRequest" class="mt-2" skeletonData>
        <label class="text-sm font-semibold ml-1">Old Appointment:</label>

        <div
            class="flex w-full bg-color-secondary-50 rounded-l-lg border-1 border-dashed border-color-base-border"
            style="border-radius: 8px"
        >
            <!-- Date section -->
            <div class="flex items-center self-stretch min-w-[80px] px-4 border-r-1 border-dashed border-color-base-border">
                <div class="flex flex-col items-center">
                    <div class="text-text-secondary text-sm leading-[140%]">
                        {{ getBookingDate(oldAppointmentRequest.datetime) | date: 'EEE' }}
                    </div>
                    <div class="text-text-secondary text-md font-semibold leading-[140%] mt-1">
                        {{ getBookingDate(oldAppointmentRequest.datetime) | date: 'MMM d' }}
                    </div>
                    <div class="text-text-secondary text-sm leading-[140%] mt-1">
                        {{ getBookingDate(oldAppointmentRequest.datetime) | date: 'yyyy' }}
                    </div>
                </div>
            </div>

            <!-- Appointment details -->
            <div class="flex pl-4 py-2 pr-2 flex-col items-start gap-2 flex-1">
                <div class="flex justify-between items-center self-stretch">
                    <div class="text-lg text-text-secondary">
                        {{ getBookingTime(oldAppointmentRequest.datetime) }}
                    </div>

                    <div
                        class="flex h-10 px-4 justify-center items-center gap-1 rounded bg-color-secondary-50"
                        *ngIf="shouldShowServicePrice && oldAppointmentRequest?.service && oldAppointmentRequest.service.length > 0"
                    >
                        <span class="text-lg font-semibold text-text-secondary">
                            {{
                                getServicesPrice(oldAppointmentRequest.service)
                                    | currency
                                        : currencyCode
                                        : 'symbol'
                                        : (getServicesPrice(oldAppointmentRequest.service) % 1 != 0 ? '1.2' : '1.0')
                            }}
                        </span>
                    </div>
                </div>

                <!-- Service details section -->
                <div class="flex flex-col items-start self-stretch">
                    <div class="text-sm font-semibold text-text-secondary" *ngFor="let service of oldAppointmentRequest?.service">
                        {{ service.name }}
                    </div>

                    <div class="text-sm text-text-secondary">
                        {{ oldAppointmentRequest.employee[0].name }}
                    </div>

                    <div
                        class="text-sm text-text-primary"
                        *ngIf="
                            isServicePriceAndDurationFeatureActive &&
                            oldAppointmentRequest?.service &&
                            oldAppointmentRequest.service.length > 0
                        "
                    >
                        {{ getServicesDuration(oldAppointmentRequest.service) | duration }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- New Appointment Section -->
    <div *ngIf="isRescheduleAppointment" class="mt-3" skeletonData>
        <label class="text-sm font-semibold ml-1">New Appointment:</label>
    </div>
    <div
        class="flex w-full bg-white rounded-lg border-[1px] border-base-border bg-base-bg"
        [ngClass]="{
            'mt-4': !isRescheduleAppointment,
        }"
        *ngIf="appointmentRequest?.datetime && !isRequestAppointmentOnly"
        skeletonData
    >
        <!-- Date section -->
        <div class="flex items-center self-stretch rounded-l-md bg-primary-base/80 text-white min-w-[80px] px-4">
            <div class="flex flex-col items-center">
                <div class="text-white text-sm font-normal leading-[140%]">
                    {{ getBookingDate(appointmentRequest.datetime) | date: 'EEE' }}
                </div>
                <div class="text-white text-md font-semibold leading-[140%] mt-1">
                    {{ getBookingDate(appointmentRequest.datetime) | date: 'MMM d' }}
                </div>
                <div class="text-white text-sm font-normal leading-[140%] mt-1">
                    {{ getBookingDate(appointmentRequest.datetime) | date: 'yyyy' }}
                </div>
            </div>
        </div>

        <!-- Appointment details -->
        <div class="flex pl-4 py-2 pr-2 flex-col items-start gap-2 flex-1">
            <div class="flex justify-between items-center self-stretch">
                <div class="text-lg text-text-primary">{{ getBookingTime(appointmentRequest.datetime) }}</div>
                <div
                    class="flex h-10 px-4 justify-center items-center gap-1 rounded bg-primary-light"
                    *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    <span class="text-lg font-semibold text-text-primary">
                        {{ getTotalPrice() | currency: currencyCode : 'symbol' : (getTotalPrice() % 1 != 0 ? '1.2' : '1.0') }}
                    </span>
                </div>
            </div>

            <!-- Service details section -->
            <div class="flex flex-col items-start self-stretch">
                <div class="text-sm font-semibold text-text-primary" *ngFor="let service of appointmentRequest?.service">
                    {{ service.name }}
                </div>
                <div class="text-sm text-text-secondary">{{ appointmentRequest.employee[0].name }}</div>
                <div
                    class="text-sm text-text-primary"
                    *ngIf="isServicePriceAndDurationFeatureActive && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    {{ getTotalDuration() | duration }}
                </div>
            </div>

            <!-- Pet Information -->
            <div
                *ngIf="supportsPets && appointmentRequest?.petInfo && appointmentRequest.petInfo.name"
                class="flex items-center justify-between self-stretch pt-2"
            >
                <div class="text-sm font-semibold text-text-primary">
                    {{ appointmentRequest.petInfo.name }}
                </div>
                <!-- Only show Switch Pet button for logged-in users -->
                <button
                    *ngIf="userLoggedIn"
                    hlmBtn
                    variant="link"
                    class="text-primary-dark text-base underline-offset-2 hover:underline"
                    (click)="onSwitchPet()"
                >
                    Switch Pet
                </button>
            </div>
        </div>
    </div>

    <!-- Requested Times Section (Request Appointment Only) -->
    <div
        class="flex w-full flex-col bg-white rounded-lg border-[1px] border-base-border bg-base-bg"
        [ngClass]="{
            'mt-4': !isRescheduleAppointment,
        }"
        *ngIf="appointmentRequest && isRequestAppointmentOnly"
        skeletonData
    >
        <!-- Service details + price row -->
        <div class="flex justify-between items-start p-2">
            <div class="flex flex-col items-start">
                <div class="text-sm font-semibold text-text-primary" *ngFor="let service of appointmentRequest?.service">
                    {{ service.name }}
                </div>
                <div class="text-sm text-text-secondary">{{ appointmentRequest.employee[0].name }}</div>
                <div
                    class="text-sm font-normal text-text-primary"
                    *ngIf="isServicePriceAndDurationFeatureActive && appointmentRequest?.service && appointmentRequest.service.length > 0"
                >
                    <ng-container *ngIf="isRequestOnlyAndFirstAvailableEmployee() && anyServiceHasDurationException()">up to </ng-container>
                    {{ getTotalDuration() | duration }}
                </div>
            </div>
            <div
                class="flex h-8 px-4 justify-center items-center gap-1 rounded bg-primary-light"
                *ngIf="shouldShowServicePrice && appointmentRequest?.service && appointmentRequest.service.length > 0"
            >
                <span class="text-md font-semibold text-text-primary">
                    {{ getTotalPrice() | currency: currencyCode : 'symbol' : (getTotalPrice() % 1 != 0 ? '1.2' : '1.0')
                    }}<ng-container *ngIf="isRequestOnlyAndFirstAvailableEmployee() && anyServiceHasPriceException()">+</ng-container>
                </span>
            </div>
        </div>

        <!-- Separator -->
        <div class="border-t border-base-border mx-2"></div>

        <!-- Requested Times list -->
        <div class="flex flex-col items-start gap-2 p-2 flex-[1_0_0]">
            <div class="text-md font-semibold text-[#000] self-stretch">Requested Times</div>
            <ul class="list-disc pl-5">
                <li *ngFor="let entry of getGroupedDateTimeOfDays()" class="text-sm text-[#000] leading-6">
                    <span class="font-bold">{{ entry.date | date: 'EEE, MMM d' }}</span
                    ><span class="font-normal"> : {{ entry.labels }}</span>
                </li>
            </ul>
        </div>

        <!-- Pet Information -->
        <div
            *ngIf="supportsPets && appointmentRequest?.petInfo && appointmentRequest.petInfo.name"
            class="flex items-center justify-between self-stretch px-4 pb-4"
        >
            <div class="text-sm font-semibold text-text-primary">
                {{ appointmentRequest.petInfo.name }}
            </div>
            <button
                *ngIf="userLoggedIn"
                hlmBtn
                variant="link"
                class="text-primary-dark text-base underline-offset-2 hover:underline"
                (click)="onSwitchPet()"
            >
                Switch Pet
            </button>
        </div>
    </div>

    <!-- Business Location -->
    <div
        class="flex py-3 px-0 flex-col items-start gap-2 self-stretch rounded-lg border-[1px] border-base-border bg-base-bg mt-4"
        *ngIf="siteSettings && siteSettings.businessAddress"
        skeletonData
    >
        <div class="flex px-3 items-center gap-4 self-stretch">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 18 25" fill="none" class="flex-shrink-0">
                <path
                    d="M2.25 8.84063C2.25 5.23594 5.23594 2.25 9 2.25C12.7641 2.25 15.75 5.23594 15.75 8.84063C15.75 10.9781 14.6344 13.5984 12.9891 16.2047C11.6625 18.3047 10.1297 20.1797 9 21.4594C7.87031 20.1797 6.34219 18.3094 5.01094 16.2047C3.36563 13.6031 2.25 10.9781 2.25 8.84063ZM9 0C4.03125 0 0 3.95625 0 8.84063C0 14.4328 5.63437 21.1359 7.9875 23.6906C8.54062 24.2906 9.45938 24.2906 10.0125 23.6906C12.3656 21.1359 18 14.4328 18 8.84063C18 3.95625 13.9688 0 9 0ZM7.5 9C7.5 8.60218 7.65804 8.22064 7.93934 7.93934C8.22064 7.65804 8.60218 7.5 9 7.5C9.39782 7.5 9.77936 7.65804 10.0607 7.93934C10.342 8.22064 10.5 8.60218 10.5 9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5C8.60218 10.5 8.22064 10.342 7.93934 10.0607C7.65804 9.77936 7.5 9.39782 7.5 9ZM12.75 9C12.75 8.00544 12.3549 7.05161 11.6517 6.34835C10.9484 5.64509 9.99456 5.25 9 5.25C8.00544 5.25 7.05161 5.64509 6.34835 6.34835C5.64509 7.05161 5.25 8.00544 5.25 9C5.25 9.99456 5.64509 10.9484 6.34835 11.6517C7.05161 12.3549 8.00544 12.75 9 12.75C9.99456 12.75 10.9484 12.3549 11.6517 11.6517C12.3549 10.9484 12.75 9.99456 12.75 9Z"
                    fill="#5D556D"
                />
            </svg>

            <div class="flex flex-col gap-1">
                <div class="text-lg font-semibold text-text-primary">{{ siteSettings.businessName }}</div>
                <div class="text-sm text-text-secondary">{{ siteSettings.businessAddress }}</div>
            </div>
        </div>
    </div>

    <!-- Comments Section -->
    <div *ngIf="showCommentsField" class="flex flex-col gap-2 mt-4" skeletonData>
        <div class="text-sm font-semibold ml-1">Special requests or comments (optional)</div>

        <textarea
            id="comments"
            [(ngModel)]="comments"
            (blur)="saveComment()"
            rows="4"
            maxlength="80"
            placeholder="Enter your special requests or comments here..."
            class="w-full resize-none border-[1px] border-base-border rounded-lg p-3 text-sm focus:outline-none focus:border-warning-dark focus:ring-0 focus:ring-primary-dark -mt-1"
        ></textarea>
    </div>

    <!-- Cancellation Policy Section -->
    <div class="flex flex-col gap-4 mt-4 text-sm text-gray-700" skeletonData>
        <div *ngIf="shouldDisplayCancellationSection" class="rounded-xl border-[1px] border-base-border p-4">
            <div class="flex items-center gap-2 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-primary-dark" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M9.99982 3.54375L4.28419 5.96875C4.09982 6.04688 3.99982 6.2125 4.00294 6.36875C4.01857 9.225 5.20294 14.1594 9.82794 16.3719C9.94044 16.425 10.0717 16.425 10.1811 16.3719C14.8061 14.1594 15.9904 9.225 16.0029 6.36875C16.0029 6.2125 15.9061 6.05 15.7217 5.96875L9.99982 3.54375ZM10.4186 2.09063L16.3061 4.5875C16.9936 4.87813 17.5061 5.55625 17.5029 6.375C17.4873 9.475 16.2123 15.1469 10.8279 17.725C10.3061 17.975 9.69982 17.975 9.17794 17.725C3.79044 15.1469 2.51544 9.475 2.50294 6.375C2.49982 5.55625 3.01232 4.87813 3.69982 4.5875L9.58419 2.09063C9.71544 2.03125 9.85607 2 9.99982 2C10.1436 2 10.2873 2.03125 10.4186 2.09063Z"
                    />
                </svg>

                <div class="text-md font-semibold text-text-primary">Cancellation Policy:</div>
            </div>

            <p class="text-[14px] text-text-primary leading-relaxed">
                {{ siteSettings.apptCancellationPolicy }}
            </p>
        </div>
    </div>

    <!-- Credit Card Section -->
    <div
        *ngIf="showCCInformation"
        class="flex flex-col gap-4 rounded-md border-[1px] border-base-border p-4 mt-4"
        id="credit-card-section"
        [ngClass]="{
            'border-base-border': creditCardForm.valid,
            'border-warning-dark': creditCardForm.invalid,
        }"
        skeletonData
    >
        <div class="flex items-center justify-between">
            <!-- Left side: Credit Card Icon + Payment Details -->
            <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-primary-dark" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        d="M16 5.5C16.275 5.5 16.5 5.725 16.5 6V7H3.5V6C3.5 5.725 3.725 5.5 4 5.5H16ZM16.5 9V14C16.5 14.275 16.275 14.5 16 14.5H4C3.725 14.5 3.5 14.275 3.5 14V9H16.5ZM4 4C2.89688 4 2 4.89688 2 6V14C2 15.1031 2.89688 16 4 16H16C17.1031 16 18 15.1031 18 14V6C18 4.89688 17.1031 4 16 4H4ZM4.5 12.75C4.5 13.1656 4.83437 13.5 5.25 13.5H6.75C7.16563 13.5 7.5 13.1656 7.5 12.75C7.5 12.3344 7.16563 12 6.75 12H5.25C4.83437 12 4.5 12.3344 4.5 12.75ZM9 12.75C9 13.1656 9.33437 13.5 9.75 13.5H11.75C12.1656 13.5 12.5 13.1656 12.5 12.75C12.5 12.3344 12.1656 12 11.75 12H9.75C9.33437 12 9 12.3344 9 12.75Z"
                    />
                </svg>
                <div class="text-md font-semibold text-text-primary">Payment Details</div>
            </div>

            <!-- Right side: Action Required Icon + Text -->
            <div *ngIf="creditCardForm.invalid" class="flex items-center gap-1 bg-warning-light px-2 py-1 rounded-md">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-warning-dark" viewBox="0 0 16 16" fill="currentColor">
                    <path
                        d="M9.33366 1.33337H4.00033C3.26699 1.33337 2.67366 1.93337 2.67366 2.66671L2.66699 13.3334C2.66699 14.0667 3.26033 14.6667 3.99366 14.6667H12.0003C12.7337 14.6667 13.3337 14.0667 13.3337 13.3334V5.33337L9.33366 1.33337ZM12.0003 13.3334H4.00033V2.66671H8.66699V6.00004H12.0003V13.3334ZM5.88033 8.70004L4.93366 9.64004L7.29366 12L11.067 8.22671L10.127 7.28671L7.30032 10.1134L5.88033 8.70004Z"
                    />
                </svg>
                <span class="text-warning-dark font-semibold text-sm">Action Required</span>
            </div>
        </div>

        <!-- Deposit Message -->
        <div hlmAlert class="!block !flex !flex-row !grid-cols-none items-start gap-2 p-3 rounded-md bg-secondary-100 mb-2 mt-1">
            <ng-icon
                hlm
                hlmAlertIcon
                name="lucideInfo"
                size="20px"
                class="mt-[2px] shrink-0"
                [style.color]="'var(--color-secondary-500, #746D83)'"
            />

            <p class="text-text-primary font-normal text-xs leading-normal">
                {{
                    isDepositExist()
                        ? 'A deposit is required to book your appointment. Your remaining balance will be due at the time of your appointment.'
                        : 'Your card will be securely saved to hold your appointment. You will be charged after your service is complete.'
                }}
            </p>
        </div>

        <!-- Deposit Info -->
        <div *ngIf="isDepositExist()" class="flex flex-col gap-2 rounded-md border-[1px] border-base-border p-4">
            <div class="flex items-center justify-between">
                <label class="text-sm text-text-primary">Deposit Amount</label>
                <label class="font-semibold">{{ depositAmount | dsbCurrency: currencyCode : 'symbol' : '1.0-2' }}</label>
            </div>
            <div class="border-t border-base-border"></div>
            <div *ngIf="stripeSurchargeEnabled && stripeSurchargeRate > 0" class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <label class="text-sm text-text-secondary" qa="surcharge">
                        <span class="font-semibold">Credit Card Fees:</span>
                        A {{ formatPercentage(stripeSurchargeRate) }} processing fee will be added where applicable.
                    </label>
                </div>
            </div>
        </div>

        <!-- Stripe -->
        <div *ngIf="isStripeEnabled" id="stripe-payment-element" data-testid="stripe-payment-element" class="stripe-payment-element"></div>

        <!-- Card Connect -->
        <div *ngIf="isCardConnectEnabled" #cCInformationContainer>
            <form [formGroup]="creditCardForm">
                <!-- Card Number -->
                <div class="flex flex-col">
                    <label class="text-sm font-semibold text-text-primary">
                        Card Number
                        <span class="text-sm font-semibold text-negative-base">*</span>
                    </label>
                    <iframe
                        qa="token-frame"
                        title="Token Frame"
                        id="tokenFrame"
                        name="tokenFrame"
                        [src]="url | safeResourceUrl"
                        class="h-10"
                    ></iframe>
                    <input type="hidden" name="cardToken" id="cardToken" formControlName="cardToken" />
                    <ng-container *ngIf="cardToken?.touched && cardToken?.invalid">
                        <p class="text-negative-base text-xs mt-1" *ngIf="cardToken?.errors?.required">Credit card number is required</p>
                        <p class="text-negative-base text-xs mt-1" *ngIf="cardToken?.errors?.invalidCreditCardNum">
                            Invalid credit card number
                        </p>
                    </ng-container>
                </div>

                <!-- In single row: Security Code, Expiration, Zip -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
                    <!-- Security Code -->
                    <div class="flex flex-col">
                        <label class="text-sm font-semibold text-text-primary">
                            Security Code
                            <span class="text-sm font-semibold text-negative-base">*</span>
                        </label>
                        <input
                            hlmInput
                            qa="security-code"
                            placeholder="CVV"
                            formControlName="securityCode"
                            maxlength="4"
                            class="border-[1px] rounded-md px-3 py-2"
                        />
                        <ng-container *ngIf="securityCode?.touched && securityCode?.invalid">
                            <p class="text-negative-base text-xs mt-1" *ngIf="securityCode?.errors?.required">Security code is required</p>
                            <p class="text-negative-base text-xs mt-1" *ngIf="!securityCode?.errors?.required">Invalid security code</p>
                        </ng-container>
                    </div>

                    <!-- Expiration -->
                    <div class="flex flex-col">
                        <label class="text-sm font-semibold text-text-primary">
                            Expiration
                            <span class="text-sm font-semibold text-negative-base">*</span>
                        </label>
                        <input
                            hlmInput
                            qa="expiration"
                            maxlength="5"
                            placeholder="MM/YY"
                            mask="00/00"
                            formControlName="expiration"
                            class="border-[1px] rounded-md px-3 py-2"
                        />
                        <ng-container *ngIf="expiration?.touched && expiration?.invalid">
                            <p class="text-negative-base text-xs mt-1" *ngIf="expiration?.errors?.required">Expiration is required</p>
                            <p class="text-negative-base text-xs mt-1" *ngIf="expiration?.errors?.creditCardExpired">
                                Invalid expiration date
                            </p>
                        </ng-container>
                    </div>

                    <!-- Zip Code -->
                    <div class="flex flex-col">
                        <label class="text-sm font-semibold text-text-primary">
                            Zip Code
                            <span class="text-sm font-semibold text-negative-base">*</span>
                        </label>
                        <input
                            hlmInput
                            qa="zip-code"
                            maxlength="5"
                            placeholder="Zip"
                            formControlName="zipCode"
                            class="border-[1px] rounded-md px-3 py-2"
                        />
                        <ng-container *ngIf="zipCode?.touched && zipCode?.invalid">
                            <p class="text-negative-base text-xs mt-1" *ngIf="zipCode?.errors?.required">Zip Code is required</p>
                            <p class="text-negative-base text-xs mt-1" *ngIf="!zipCode?.errors?.required">Invalid zip code</p>
                        </ng-container>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Book Appointment Button -->
    <div class="fixed bottom-0 left-0 right-0 mx-auto max-w-[var(--dsb-content-max-width)] py-md px-lg bg-white">
        <button
            hlmBtn
            class="w-full"
            (click)="bookAppointment()"
            [disabled]="
                !canBookAppointment() ||
                isBookAppointmentClicked ||
                (!showCCInformation ? false : isStripeEnabled ? false : creditCardForm && creditCardForm.invalid)
            "
        >
            {{ isRescheduleAppointment ? 'Reschedule' : 'Book' }} Appointment
            <hlm-spinner *ngIf="isBookAppointmentClicked" class="size-4 [&>svg]:!fill-white" />
        </button>
    </div>
</div>

<!-- Main Sheet -->
<hlm-sheet #main side="bottom" [closeOnBackdropClick]="false" [closeOnOutsidePointerEvents]="false" (closed)="onMainSheetFullyClosed()">
    <hlm-sheet-content *brnSheetContent="let ctx">
        <hlm-sheet-header>
            <div class="flex items-center mt-2 gap-2">
                <ng-icon hlm name="lucideChevronLeft" size="base" (click)="onGoBack()" class="cursor-pointer"></ng-icon>
                <label hlmLabel hlmSheetTitle class="text-lg">Edit appointment</label>
            </div>
        </hlm-sheet-header>

        <div class="flex justify-center gap-4 mx-4 mt-4">
            <button hlmBtn variant="outline" type="button" class="flex-1 h-12 text-base" (click)="onOpenSheet(sheet.Login)">Log In</button>
            <button hlmBtn variant="outline" type="button" class="flex-1 h-12 text-base" (click)="onOpenSheet(sheet.Create)">
                Create Account
            </button>
        </div>

        <div class="flex items-center gap-2 pt-4 mx-4 mt-2 px-2">
            <div class="flex-1 border-t border-base-border"></div>
            <span class="text-sm text-gray-500 px-4">or</span>
            <div class="flex-1 border-t border-base-border"></div>
        </div>

        <hlm-sheet-footer class="pb-6 text-center">
            <button type="button" class="text-base text-primary-dark cursor-pointer" (click)="onOpenSheet(sheet.Checkout)">
                Checkout as Guest
            </button>
        </hlm-sheet-footer>
    </hlm-sheet-content>
</hlm-sheet>

<!-- Log In Sheet -->
<hlm-sheet #login side="bottom" [closeOnBackdropClick]="false" [closeOnOutsidePointerEvents]="false" (closed)="onLoginSheetFullyClosed()">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="login-sheet">
        <hlm-sheet-header class="pl-0">
            <div class="flex items-center justify-between mt-2">
                <h1 hlmSheetTitle>Log In</h1>

                <ng-icon
                    hlm
                    name="lucideX"
                    size="lg"
                    (click)="onCloseSheet(sheet.Login)"
                    class="cursor-pointer text-gray-500 hover:text-gray-700"
                ></ng-icon>
            </div>
        </hlm-sheet-header>
        <div>
            <app-login-form (closeSheet)="onCloseSheet($event)" (closeContainer)="onAccountCreatedFromLoginSheet($event)"></app-login-form>
        </div>
    </hlm-sheet-content>
</hlm-sheet>

<!-- Create Account Sheet -->
<hlm-sheet
    #create
    side="bottom"
    class="max-h-[80vh] flex flex-col"
    [closeOnBackdropClick]="false"
    [closeOnOutsidePointerEvents]="false"
    (closed)="onCreateSheetFullyClosed()"
>
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="create-sheet">
        <hlm-sheet-header class="pl-0 flex-shrink-0 pt-[50px]">
            <div class="flex items-center justify-between mt-2 pr-2">
                <h1 hlmSheetTitle class="text-lg">Create Account</h1>

                <ng-icon
                    hlm
                    name="lucideX"
                    size="base"
                    (click)="onCloseSheet(sheet.Create)"
                    class="cursor-pointer text-gray-500 hover:text-gray-700 flex-shrink-0"
                ></ng-icon>
            </div>
        </hlm-sheet-header>
        <div class="flex-1 overflow-y-auto">
            <app-create-account-form
                (closeSheet)="onCloseSheet($event)"
                (accountCreated)="onAccountCreatedFromCreateSheet()"
            ></app-create-account-form>
        </div>
    </hlm-sheet-content>
</hlm-sheet>

<!-- Checkout as Guest Sheet -->
<hlm-sheet #checkout side="bottom" class="max-h-[80vh] flex flex-col" [closeOnBackdropClick]="false" [closeOnOutsidePointerEvents]="false">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="checkout-sheet">
        <hlm-sheet-header class="flex-shrink-0 !px-lg pt-[50px]">
            <div *ngIf="isEditClicked" class="flex items-center justify-between mt-2">
                <h1 hlmSheetTitle class="text-lg">Checkout as Guest</h1>

                <ng-icon
                    hlm
                    name="lucideX"
                    size="base"
                    (click)="onCloseSheet(sheet.Checkout)"
                    class="cursor-pointer text-gray-500 hover:text-gray-700 flex-shrink-0"
                ></ng-icon>
            </div>

            <div *ngIf="!isEditClicked" class="flex items-center justify-between mt-2">
                <h1 hlmSheetTitle class="text-lg">Checkout as Guest</h1>

                <ng-icon
                    hlm
                    name="lucideX"
                    size="base"
                    (click)="onCloseSheet(sheet.Checkout)"
                    class="cursor-pointer text-gray-500 hover:text-gray-700 flex-shrink-0"
                ></ng-icon>
            </div>
        </hlm-sheet-header>

        <div class="flex-1 overflow-y-auto">
            <app-create-account-form
                [actionButtonText]="'Continue'"
                [showPassword]="false"
                (closeSheet)="onCheckoutFormComplete($event)"
            ></app-create-account-form>
        </div>
    </hlm-sheet-content>
</hlm-sheet>

<!-- Add Pet Sheet (for guest checkout with pets) -->
<hlm-sheet #petInfo side="bottom" class="max-h-[80vh] flex flex-col" [closeOnBackdropClick]="false" [closeOnOutsidePointerEvents]="false">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="pet-info-sheet">
        <hlm-sheet-header class="flex-shrink-0 !px-lg pt-[50px]">
            <div class="flex items-center gap-2" *ngIf="!isCreateAccountFlow">
                <button (click)="onBackFromPetInfo()" class="flex items-center gap-1 cursor-pointer text-text-primary">
                    <ng-icon hlm name="lucideChevronLeft" size="base"></ng-icon>
                    <span class="text-md font-normal text-text-primary">Back</span>
                </button>
            </div>
        </hlm-sheet-header>

        <div class="flex-1 overflow-y-auto px-lg">
            <app-pet-information
                #petInfoComponent
                [showAddPetTitle]="true"
                [userLoggedIn]="userLoggedIn"
                (isValidFormChange)="onPetFormValidityChange($event)"
            ></app-pet-information>
        </div>

        <hlm-sheet-footer class="pb-6 px-lg">
            <button hlmBtn class="w-full rounded-lg text-md font-normal" [disabled]="!isPetFormValid" (click)="onAddPetComplete()">
                Add Pet
            </button>
        </hlm-sheet-footer>
    </hlm-sheet-content>
</hlm-sheet>

<!-- Select Pet Sheet (for logged-in users with pets) -->
<hlm-sheet #petList side="bottom" class="max-h-[80vh] flex flex-col" [closeOnBackdropClick]="false" [closeOnOutsidePointerEvents]="false">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="pet-list-sheet">
        <hlm-sheet-header class="flex-shrink-0 pt-6"></hlm-sheet-header>

        <div class="flex-1 overflow-y-auto">
            <app-pet-list
                #petListComponent
                (isValidFormChange)="onPetListValidityChange($event)"
                (addPetClick)="onAddPetFromList()"
                (logoutClick)="onNotYouFromPetList()"
            ></app-pet-list>
        </div>

        <hlm-sheet-footer class="pb-6 px-lg">
            <button hlmBtn class="w-full rounded-lg text-md font-normal" [disabled]="!isPetSelected" (click)="onPetListComplete()">
                Continue
            </button>
        </hlm-sheet-footer>
    </hlm-sheet-content>
</hlm-sheet>

<hlm-toaster />
